<template>
  <div>
    <Reports></Reports>
  </div>
</template>
<script>
  import {mapActions, mapGetters} from 'vuex';
  // import consts from '../../../_consts';
  import Reports from '../../../components/eventManagement/main/Reports.vue';

  import Icon from 'vue-awesome/components/Icon';

  import 'vue-awesome/icons/file-excel-o';
  import 'vue-awesome/icons/question-circle-o';
  import 'vue-awesome/icons/sort-down';
  import 'vue-awesome/icons/users';

  export default {
    name: 'c-report-page',
    components: {
      Icon,
      Reports
    },
    props: {},
    data () {
      return {
      };
    },
    computed: {
      ...mapGetters({
      })
    },
    methods: {
      ...mapActions({
      })
    },
    beforeMount () {},
    mounted () {
    },
    watch: {
    }
  };
</script>

<style lang="less">
  @import '~@/styles/variables.less';
</style>



// WEBPACK FOOTER //
// Reports.vue?10aeaa11